/* eslint import/prefer-default-export: 0 */
export const serviceConfig = {
  resourceBaseAddress: "https://stg-api-go-nl.groupm.com/api"
};
